import VersionListItem from './VersionListItem';

import './VersionListItem.scss';

export default VersionListItem;
